import webshop from '@wwdev/webshop';
import Checkout from "@wwdev/webshop/checkout";
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import Popup from '@wwdev/webshop/popup';
import Form from "@wwdev/winkelwagen/form";
import Filters from "@wwdev/product"

webshop.basket.init();
webshop.shipping.init();

(new Popup).init({
	'btn_order_class': 'btn-primary'
});

Checkout.init();

Bindings.init();

Variants.init();
